export const InitialState = {
    isLoading: false,
    quantity: 0,
    price: 0,
    product: undefined,
    purchaseOrder: undefined,
    packageId: undefined,
    matchType: '',
    productDisplay: '',
    productDescription: '',
    nonProductFieldsDisabled: true,
    fastLineDetails: undefined,
    lastChangedField: undefined,
    priceDisabled: false,
    isInvalidProduct: false,
    apply: false,
    disablePurchaseOrderLookup: false,
};

export const RESET_WAIT = 300;
export const MINIMUMSIZESCREEN = 913;
